import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { WorkspaceProvider } from "./hooks/useApi";
import { ThemeProvider } from "./hooks/useTheme";
import { FieldMode } from "./pages/FieldMode";
import { FocusMode } from "./pages/FocusMode";
import { DeckManager } from "./pages/DeckManager";
import { BackupSettings } from "./pages/BackupSettings";
import { LibraryPage } from "./pages/LibraryPage";
import { ImportHelp } from "./pages/ImportHelp";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";

function AppRoutes() {
  return (
    <WorkspaceProvider>
      <Routes>
        <Route path="/" element={<FieldMode />} />
        <Route path="/card/:cardId" element={<FocusMode />} />
        <Route path="/decks" element={<DeckManager />} />
        <Route path="/backup" element={<BackupSettings />} />
        <Route path="/sync" element={<BackupSettings />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/import-help" element={<ImportHelp />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </WorkspaceProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
